import { useState } from "react"
import Banner from "../components/financialAidScholarship/banner"
import AboutFinAidPlatform from "../sections/aboutFinAidPlatform"
import Filter from "../components/financialAidScholarship/filter"
import AnimatedPage from "../components/animatedPage"


const FinancialAidScholarship = () => {

    const [intake, setIntake] = useState("");
    const [searchText, setSearchText] = useState("");
  
    const [dropDownData,] = useState([]);

  


    return (
        <AnimatedPage>
            <div className="flex flex-col bg-white">
                <Banner />
                <Filter handleIntake={setIntake}  search={searchText} setSearch={setSearchText} data={dropDownData} />
                <AboutFinAidPlatform closedate={intake} searchText={searchText} />
            </div>
        </AnimatedPage>
    )
}

export default FinancialAidScholarship